import { writable } from "svelte/store";

export const notifications = writable([]);

export function notify({ title, body, type }, duration = 2000) {
    const notification = { title, body, type };
    const uid = setTimeout(() => {
        if (duration)
            notifications.update((value) =>
                value.filter(({ uid: it }) => it !== uid)
            );
    }, duration);
    notification.uid = uid;
    notifications.update((value) => [...value, notification]);
    return notification;
}

export function notifyError(title, body, duration = 3000) {
    notify({ title, body, type: "error" }, duration);
}

export function notifyInfo(title, body, duration = 3000) {
    notify({ title, body, type: "info" }, duration);
}

export function notifyWarn(title, body, duration = 3000) {
    notify({ title, body, type: "warn" }, duration);
}

export function notifySuccess(title, body, duration = 3000) {
    notify({ title, body, type: "success" }, duration);
}

export function notifyBasic(title, body, duration = 3000) {
    notify({ title, body, type: "basic" }, duration);
}
